@if (isLoaded()) {
  <div
    class="icon-inner"
    [style.width]="size()"
    [style.height]="size()"
    [class.icon-gradient]="isGradient()"
    [style.mask]="isGradient() ? gradientMask() : null"
    [style.-webkit-mask]="isGradient() ? gradientMask() : null"
  >
    <svg class="svg-wrapper" [attr.width]="size()" [attr.height]="size()">
      <use class="svg-use" [attr.xlink:href]="svgName()"></use>
    </svg>
  </div>
}
